import React from "react";
import PageHero from "@/components/PageHero";
import { Container, GoldButton } from "@/components/shared";

export default function Press() {
  return (
    <div>
      <PageHero
        kicker="Press"
        title="For journalists and broadcasters"
        intro="Reporting on the two Bostons or the 2030 anniversary? We are glad to help, and to be clear about what this project is — and is not."
      />

      <section className="py-16 sm:py-24">
        <Container>
          <div className="max-w-3xl mx-auto space-y-8">
            <div>
              <h2 className="font-serif text-2xl text-[#003366] mb-3">In one line</h2>
              <p className="font-sans text-lg text-[#1B2430] leading-relaxed">
                Made in Boston is an independent, privately run crossing connecting Boston,
                Lincolnshire (the mother town) and Boston, Massachusetts (the daughter city) — a
                directory of makers, a shared history, and an open line between both shores.
              </p>
            </div>

            <div className="bg-[#FFFAF3] border border-[#D6D3CB] p-8">
              <h2 className="font-serif text-xl text-[#1E1E2F] mb-4">Please note</h2>
              <ul className="space-y-3 font-sans text-base text-[#1B2430] leading-relaxed">
                <li>· This is not a council website, not Boston 400, and not a government initiative.</li>
                <li>· It is the work of a private citizen; please describe it as independent.</li>
                <li>· We use “mother town” and “daughter city”, not “sister cities” or “twin towns”.</li>
                <li>· The 1630 migration was the Puritan Massachusetts Bay settlement — distinct from the 1620 Plymouth landing.</li>
              </ul>
            </div>

            <div>
              <h2 className="font-serif text-2xl text-[#003366] mb-3">Press enquiries</h2>
              <p className="font-sans text-lg text-[#1B2430] leading-relaxed">
                Email <a href="mailto:press@madeinboston.co.uk" className="text-[#003366] link-underline">press@madeinboston.co.uk</a>.
                We can provide background, quotes, and the emblem for print or screen.
              </p>
            </div>

            <GoldButton as="link" to="/contact">Contact the project</GoldButton>
          </div>
        </Container>
      </section>
    </div>
  );
}
